import type { Artwork } from "../types/artwork";

export const seedArtworks: Artwork[] = [
  {
    "id": "artwork-2154",
    "wordpressId": 2154,
    "sku": "JHA001",
    "slug": "after-the-storm",
    "title": "After The Storm",
    "description": "Oil on Paper. An abstract seascape illustrating the foreboding colours of a storm but also capturing the hope of better times as the storm passes",
    "pricePence": 14500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "after-the-storm.jpg",
    "imageUrl": "/artworks/after-the-storm.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": 2.25,
    "displayOrder": 1,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.809Z"
  },
  {
    "id": "artwork-2155",
    "wordpressId": 2155,
    "sku": "JHA002",
    "slug": "at-giverny",
    "title": "At Giverny",
    "description": "Oil Painting inspired to a visit to Monet's Garden at Giverny.I wanted to capture the paradox of the exuberance and untamed nature of the planting in a formal garden.",
    "pricePence": 7500,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "at-giverny.jpg",
    "imageUrl": "/artworks/at-giverny.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": 2.25,
    "displayOrder": 2,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.810Z"
  },
  {
    "id": "artwork-2156",
    "wordpressId": 2156,
    "sku": "JHA003",
    "slug": "blue-mist",
    "title": "Blue Mist",
    "description": "Oil on Canvas Tranquil coastal seascape created by painting wet on wet and blending on the canvas .",
    "pricePence": 12500,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "blue-mist.jpg",
    "imageUrl": "/artworks/blue-mist.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": 2.25,
    "displayOrder": 3,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.812Z"
  },
  {
    "id": "artwork-2157",
    "wordpressId": 2157,
    "sku": "JHA004",
    "slug": "blue",
    "title": "Blue",
    "description": "Oil on Paper. A modernist representation of a city scape",
    "pricePence": 8000,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "blue.jpg",
    "imageUrl": "/artworks/blue.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": 2.25,
    "displayOrder": 4,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.812Z"
  },
  {
    "id": "artwork-2158",
    "wordpressId": 2158,
    "sku": "JHA005",
    "slug": "restless",
    "title": "Restless",
    "description": "Oil blended with cold wax to enhance depth. A monochromatic picture depicting the quiet restlessness before a storm.",
    "pricePence": 15000,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "restless.jpg",
    "imageUrl": "/artworks/restless.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": 2.25,
    "displayOrder": 5,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.814Z"
  },
  {
    "id": "artwork-2159",
    "wordpressId": 2159,
    "sku": "JHA006",
    "slug": "dark-times",
    "title": "Dark Times",
    "description": "Oil painting created on the day that Russia invaded Ukraine The painting reflects my sense of despair at the stupidity of war for personal glory and territorial gain.",
    "pricePence": 15000,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "dark-times.jpg",
    "imageUrl": "/artworks/dark-times.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": 2.25,
    "displayOrder": 6,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.814Z"
  },
  {
    "id": "artwork-2160",
    "wordpressId": 2160,
    "sku": "JHA007",
    "slug": "evening-in-the-hills",
    "title": "Evening in the Hills",
    "description": "Oil blended with cold wax. The aim of this picture was to capture the soft and warm light of evening through the careful selection of warm colours.",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "evening-in-the-hills.jpg",
    "imageUrl": "/artworks/evening-in-the-hills.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": -0.25,
    "displayOrder": 7,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.816Z"
  },
  {
    "id": "artwork-2161",
    "wordpressId": 2161,
    "sku": "JHA008",
    "slug": "first-days-of-summer",
    "title": "First Days of Summer",
    "description": "Oil on canvas. This picture was painted in the middle of winter when I was remembering those clear, beautiful days of summer. A picture full of hope of days to come.",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "first-days-of-summer.jpg",
    "imageUrl": "/artworks/first-days-of-summer.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": -0.25,
    "displayOrder": 8,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.817Z"
  },
  {
    "id": "artwork-2162",
    "wordpressId": 2162,
    "sku": "JHA009",
    "slug": "boggy-lands",
    "title": "Boggy Lands",
    "description": "An oil painting designed to depict the eeie stillness of boggy marshes. Mood is created by the selection of muted colours and the blending od paints on the paper whilst still wet.",
    "pricePence": 7500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "boggy-lands.jpg",
    "imageUrl": "/artworks/boggy-lands.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": -0.25,
    "displayOrder": 9,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.819Z"
  },
  {
    "id": "artwork-2163",
    "wordpressId": 2163,
    "sku": "JHA010",
    "slug": "into-blue",
    "title": "Into Blue",
    "description": "A monochromatic abstract oil painting designed to capture the still light of dusk",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "into-blue.jpg",
    "imageUrl": "/artworks/into-blue.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": -0.25,
    "displayOrder": 10,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.820Z"
  },
  {
    "id": "artwork-2164",
    "wordpressId": 2164,
    "sku": "JHA011",
    "slug": "malvern-moods",
    "title": "Malvern Moods",
    "description": "Two small oil paintings designed as a pair but equally valid as individual pictures. The Malvern Hills rise majestically from the Lanscape across Worcestershire and Herefordshire. Each day is a new picture depending on the weather conditions and the seasons.",
    "pricePence": 10000,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "malvern-moods.jpg",
    "imageUrl": "/artworks/malvern-moods.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": -0.25,
    "displayOrder": 11,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.820Z"
  },
  {
    "id": "artwork-2165",
    "wordpressId": 2165,
    "sku": "JHA012",
    "slug": "mulberry-days",
    "title": "Mulberry Days",
    "description": "Oil on paper .The soft pre autumn evening light when fruit still hangs heavy in the trees, but already the eveings have a soft chill. A calm pastoral piece inspired by the colours of red summer fruits.",
    "pricePence": 12500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "mulberry-days.jpg",
    "imageUrl": "/artworks/mulberry-days.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": -0.25,
    "displayOrder": 12,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.821Z"
  },
  {
    "id": "artwork-2166",
    "wordpressId": 2166,
    "sku": "JHA013",
    "slug": "one-of-those-days",
    "title": "One of Those Days",
    "description": "",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "one-of-those-days.jpg",
    "imageUrl": "/artworks/one-of-those-days.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": -2.75,
    "displayOrder": 13,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.822Z"
  },
  {
    "id": "artwork-2167",
    "wordpressId": 2167,
    "sku": "JHA014",
    "slug": "peach-melba-skies",
    "title": "Peach Melba Skies",
    "description": "Oil blended with cold wax to enhance the depth and transluscence of the sky. A light and frothy painting that depicts the soft days of summer",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "peach-melba-skies.jpg",
    "imageUrl": "/artworks/peach-melba-skies.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": -2.75,
    "displayOrder": 14,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.823Z"
  },
  {
    "id": "artwork-2168",
    "wordpressId": 2168,
    "sku": "JHA015",
    "slug": "profusion",
    "title": "Profusion",
    "description": "Oil Painting inspired by a visit to Monet's garden at Giverny. The aim was to capture the riot of colour in this most extravagent of cottage gardens.",
    "pricePence": 17500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "profusion.jpg",
    "imageUrl": "/artworks/profusion.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": -2.75,
    "displayOrder": 15,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.825Z"
  },
  {
    "id": "artwork-2169",
    "wordpressId": 2169,
    "sku": "JHA016",
    "slug": "red-marsh",
    "title": "Red Marsh",
    "description": "An oil and cold wax painting using red hues. A very moody painting depicting a sense of foreboding in the Marshes.",
    "pricePence": 12500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "red-marsh.jpg",
    "imageUrl": "/artworks/red-marsh.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": -2.75,
    "displayOrder": 16,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.826Z"
  },
  {
    "id": "artwork-2170",
    "wordpressId": 2170,
    "sku": "JHA017",
    "slug": "rockpools-1",
    "title": "Rockpools 1",
    "description": "Rockpools,one of a a pair of oil paintings sharing memories of childhood beach holidays in Britain and hours spent fishing in pools. Paintings are designed as a pair but would work equally well as singular pictures.",
    "pricePence": 12500,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "rockpools-1.jpg",
    "imageUrl": "/artworks/rockpools-1.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": -2.75,
    "displayOrder": 17,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.827Z"
  },
  {
    "id": "artwork-2171",
    "wordpressId": 2171,
    "sku": "JHA018",
    "slug": "rockpools2",
    "title": "Rockpools 2",
    "description": "Rockpools,one of a a pair of oil paintings sharing memories of childhood beach holidays in Britain and hours spent fishing in pools. Paintings are designed as a pair but would work equally well as singular pictures.",
    "pricePence": 10000,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "rockpools2.jpg",
    "imageUrl": "/artworks/rockpools2.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": -2.75,
    "displayOrder": 18,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.828Z"
  },
  {
    "id": "artwork-2172",
    "wordpressId": 2172,
    "sku": "JHA019",
    "slug": "shoreline",
    "title": "Shoreline",
    "description": "Oil painting using a limited colour palette to demonstrate the slimmed down colour at dusk",
    "pricePence": 8500,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "shoreline.jpg",
    "imageUrl": "/artworks/shoreline.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": 2.25,
    "displayOrder": 19,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.829Z"
  },
  {
    "id": "artwork-2173",
    "wordpressId": 2173,
    "sku": "JHA020",
    "slug": "storm-clouds-gathering",
    "title": "Storm Clouds Gathering",
    "description": "An oil painting on paper. I love the endless possibilities in painting turbulent and forbidding skies. Skies provide wonderful opportunities to play with shapes, colour and light to create a mood.",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "storm-clouds-gathering.jpg",
    "imageUrl": "/artworks/storm-clouds-gathering.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": 2.25,
    "displayOrder": 20,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.830Z"
  },
  {
    "id": "artwork-2174",
    "wordpressId": 2174,
    "sku": "JHA021",
    "slug": "icecream-days",
    "title": "Ice cream days",
    "description": "A light and fluffy picture using a summer palette and depicting happy icecream days at the beach.",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": null,
    "imageUrl": null,
    "roomWall": "right",
    "roomX": 0,
    "roomY": 2.25,
    "displayOrder": 21,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.830Z"
  },
  {
    "id": "artwork-2175",
    "wordpressId": 2175,
    "sku": "JHA022",
    "slug": "tranquil-land",
    "title": "Tranquil Land",
    "description": "A calm, pastoral scene. Using a muted colour palette . Oil blended with cold wax.",
    "pricePence": null,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "tranquil-land.jpg",
    "imageUrl": "/artworks/tranquil-land.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": 2.25,
    "displayOrder": 22,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.832Z"
  },
  {
    "id": "artwork-2176",
    "wordpressId": 2176,
    "sku": "JHA023",
    "slug": "turbulence",
    "title": "Turbulence",
    "description": "Painted when the Russian /Ukraine war started. This oil blended with cold wax picture illustrates the Turmoil brought about by the conflict.",
    "pricePence": 7500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "turbulence.jpg",
    "imageUrl": "/artworks/turbulence.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": 2.25,
    "displayOrder": 23,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.833Z"
  },
  {
    "id": "artwork-2177",
    "wordpressId": 2177,
    "sku": "JHA024",
    "slug": "warm-earth",
    "title": "Warm Earth",
    "description": "An abstract using oil paint blended with cold wax. The picture depicts the deep red earth and blue skies of hot climes. In this instance the picture was inspired by a trip to Southern Spain",
    "pricePence": 8500,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "warm-earth.jpg",
    "imageUrl": "/artworks/warm-earth.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": 2.25,
    "displayOrder": 24,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.834Z"
  },
  {
    "id": "artwork-2178",
    "wordpressId": 2178,
    "sku": "JHA025",
    "slug": "when-storm-clouds-split-the-sky",
    "title": "When Storm Clouds Split the Sky",
    "description": "Inspired by my fascination with foreboding skies. An abstracted seascape. Oil blended with cold wax",
    "pricePence": 8500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "when-storm-clouds-split-the-sky.jpg",
    "imageUrl": "/artworks/when-storm-clouds-split-the-sky.jpg",
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": -0.25,
    "displayOrder": 25,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.835Z"
  },
  {
    "id": "artwork-2252",
    "wordpressId": 2252,
    "sku": "JHA026",
    "slug": "first-days-of-summer-4",
    "title": "First Days of Summer",
    "description": "This picture captures the anticipation of summer days.It was painted in midwinter.Oil on canvas",
    "pricePence": 10000,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "first-days-of-summer-4.jpg",
    "imageUrl": "/artworks/first-days-of-summer-4.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": -0.25,
    "displayOrder": 26,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.837Z"
  },
  {
    "id": "artwork-2253",
    "wordpressId": 2253,
    "sku": "JHA027",
    "slug": "coastal-margins-3",
    "title": "Coastal Margins",
    "description": "This picture-flecxts the beauty of the British coastline oil on canvas",
    "pricePence": 10000,
    "currency": "GBP",
    "stockStatus": "outofstock",
    "published": true,
    "imageKey": "coastal-margins-3.jpg",
    "imageUrl": "/artworks/coastal-margins-3.jpg",
    "roomWall": "right",
    "roomX": 0,
    "roomY": -0.25,
    "displayOrder": 27,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.837Z"
  },
  {
    "id": "artwork-2254",
    "wordpressId": 2254,
    "sku": "JHA028",
    "slug": "the-walk-3",
    "title": "The Walk",
    "description": "Oil on canvas Tranquil rural scene.",
    "pricePence": 7500,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": null,
    "imageUrl": null,
    "roomWall": "left",
    "roomX": -4.8,
    "roomY": -0.25,
    "displayOrder": 28,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.837Z"
  },
  {
    "id": "artwork-2255",
    "wordpressId": 2255,
    "sku": "JHA029",
    "slug": "essex-marsh-3",
    "title": "Essex Marsh",
    "description": "An impressionist view of the Essex Marshes. Oil on Canvas",
    "pricePence": 10000,
    "currency": "GBP",
    "stockStatus": "instock",
    "published": true,
    "imageKey": "essex-marsh-3.jpg",
    "imageUrl": "/artworks/essex-marsh-3.jpg",
    "roomWall": "back",
    "roomX": -2.4,
    "roomY": -0.25,
    "displayOrder": 29,
    "createdAt": "2022-08-04T00:00:00.000Z",
    "updatedAt": "2026-06-29T16:42:46.839Z"
  }
];
